import React, { useCallback, useState } from "react";
import { connect } from "react-redux";
import PaymentButton from "../components/PaymentButton";
import _ from "lodash/fp";
import { selectors } from "../modules/customers";
import UpdateShoppingCart from "../containers/UpdateShoppingCart";
import { withRouter } from "react-router-dom";
import ModalWrapper from "../components/ModalWrapper";
import Button from "./CustomButton";
import LoginForm from "../containers/ShoppingCartLogin";
import SignupForm from "../containers/ShoppingCartSignup";
import { toast } from "react-toastify";

const ShoppingCartCheckoutButton = _.pipe(
  connect(state => ({
    customer: selectors.getCurrentCustomer(state)
  })),
  UpdateShoppingCart,
  withRouter
)(
  ({
    shoppingCart,
    customer,
    checkoutShoppingCart,
    submitting,
    dealerId,
    customerId,
    match: {
      params: { dealer_id }
    },
    history: { replace }
  }) => {
    const [tab, setTab] = useState("login");
    const onClickTab = useCallback(
      tab => () => {
        setTab(tab);
      },
      [setTab]
    );
    const callbackFunction = useCallback(
      async response => {
        if (shoppingCart && response && response.Status === "Successful") {
          const data = {
            payment: {
              transaction_id: response.TransactionId,
              card_data: [
                {
                  card_type: response.CardType,
                  pan: response.MaskedPAN,
                  expire: response.Expire.split("/").join(""),
                  secure_payment_account_data: response.PaymentAccountDataToken
                }
              ]
            }
          };
          const result = await checkoutShoppingCart({
            dealerId,
            customerId,
            data
          });
          if (result.response) {
            toast.success("Successful payment!");
            replace("/products");
          }
        }
      },
      [checkoutShoppingCart, customerId, dealerId, replace, shoppingCart]
    );
    if (dealer_id) {
      return (
        <div className="row my-2 justify-content-end">
          <ModalWrapper
            title={<h4>You need to be signed in to perform this action</h4>}
            render={hide => (
              <div>
                {tab === "login" && (
                  <div>
                    <LoginForm />
                    <div className="text-center" style={{ marginTop: 10 }}>
                      <p
                        className="text-info selectable"
                        onClick={onClickTab("signup")}
                      >
                        I don't have an account?
                      </p>
                    </div>
                  </div>
                )}
                {tab === "signup" && (
                  <div>
                    <SignupForm />
                    <div className="text-center" style={{ marginTop: 10 }}>
                      <p
                        className="text-info selectable"
                        onClick={onClickTab("login")}
                      >
                        I already have an account?
                      </p>
                    </div>
                  </div>
                )}
              </div>
            )}
          >
            {({ show }) => (
              <div className="col-auto">
                <Button fill onClick={show} color="primary">
                  Pay now
                </Button>
              </div>
            )}
          </ModalWrapper>
        </div>
      );
    }
    return (
      <div className="row my-2 justify-content-end">
        <div className="col-auto">
          <PaymentButton
            disabled={submitting}
            email={_.getOr("", "email", customer)}
            billingName={`${_.getOr("", "first_name", customer)} ${_.getOr(
              "",
              "last_name",
              customer
            )}`.trim()}
            amount={shoppingCart.total_cost}
            terminalProfileId={process.env.REACT_APP_NAB_VELOCITY_PROFILE}
            callbackFunction={callbackFunction}
            title="Pay Now"
          />
        </div>
      </div>
    );
  }
);

export default ShoppingCartCheckoutButton;
